import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-delete-account',
  templateUrl: './delete-account.component.html',
  styleUrls: ['./delete-account.component.scss'],
})
export class DeleteAccountComponent implements OnInit {
  deleteAccountForm!: FormGroup;
  isSubmitted: boolean = false;
  constructor(readonly fb: FormBuilder) {}

  ngOnInit(): void {
    this.deleteAccountForm = this.fb.group({
      phone: [
        '',
        [
          Validators.required,
          Validators.maxLength(10),
          Validators.minLength(10),
        ],
      ],
    });
  }
  handleSubmit() {
    this.isSubmitted = true;
    console.log(this.deleteAccountForm.value);
  }
}
